import { createContext } from "react";

export const AddUserStateContext = createContext();
